import {
  GET_CUSTOMERS,
  GET_CUSTOMERS_FAIL,
  GET_CUSTOMERS_SUCCESS,
  GET_AUTH_USER,
  GET_AUTH_USER_FAIL,
  GET_AUTH_USER_SUCCESS,
  ADD_NEW_CUSTOMER,
  ADD_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_FAIL,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAIL,
  DELETE_CUSTOMER,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAIL,
  GET_CUSTOMER_DETAIL,
  UPDATE_CUSTOMER_FIELD,
} from "./actionTypes"

export const getCustomers = page => ({
  type: GET_CUSTOMERS,
  payload: page,

})

export const getCustomersSuccess = customers => ({
  type: GET_CUSTOMERS_SUCCESS,
  payload: customers,
})

export const getCustomersFail = error => ({
  type: GET_CUSTOMERS_FAIL,
  payload: error,
})

export const getAuthUsers = auth => ({
  type: GET_AUTH_USER,
  payload: auth,

})

export const getAuthUsersSuccess = auth => ({
  type: GET_AUTH_USER_SUCCESS,
  payload: auth,
})

export const getAuthUsersFail = error => ({
  type: GET_AUTH_USER_FAIL,
  payload: error,
})

export const addNewCustomer = quote => ({
  type: ADD_NEW_CUSTOMER,
  payload: quote,
})

export const addCustomerSuccess = quote => ({
  type: ADD_CUSTOMER_SUCCESS,
  payload: quote,
})

export const addCustomerFail = error => ({
  type: ADD_CUSTOMER_FAIL,
  payload: error,
})

export const updateCustomer = customer => ({
  type: UPDATE_CUSTOMER,
  payload: customer,
})

export const updateCustomerField = customer => ({
  type: UPDATE_CUSTOMER_FIELD,
  payload: customer,
})

export const updateCustomerSuccess = quote => ({
  type: UPDATE_CUSTOMER_SUCCESS,
  payload: quote,
})

export const updateCustomerFail = error => ({
  type: UPDATE_CUSTOMER_FAIL,
  payload: error,
})

export const deleteCustomer = customer => ({
  type: DELETE_CUSTOMER,
  payload: customer,
})

export const deleteCustomerSuccess = quote => ({
  type: DELETE_CUSTOMER_SUCCESS,
  payload: quote,
})

export const deleteCustomerFail = error => ({
  type: DELETE_CUSTOMER_FAIL,
  payload: error,
})

export const getCustomerDetails = quote => ({
  type: GET_CUSTOMER_DETAIL,
  payload: quote,
})

export const getCustomerDetailFail = error => ({
  type: GET_CUSTOMER_DETAIL_FAIL,
  payload: error,
})


export const getCustomerDetailSuccess = quote => ({
  type: GET_CUSTOMER_DETAIL_SUCCESS,
  payload: quote,
})


